import classNames from 'classnames';
import { forwardRef } from 'react';
const timelineStepCss = "t1j91b1c";
export const TimelineStep = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(timelineStepCss, props.className)} />;
});
const iconContainerCss = "i1teve07";
export const IconContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconContainerCss, props.className)} />;
});
const descriptionCss = "douqw00";
export const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const rescheduleReasonTextCss = "r9tfvkh";
export const RescheduleReasonText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rescheduleReasonTextCss, props.className)} />;
});
const containerCss = "c1lcl778";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");